import LightHouse from './LightHouse'

export default LightHouse
// eslint-disable-next-line import/export
export * from './LightHouse'
